/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import { object } from 'prop-types';

import findContent from '../../../../../../../gql/queries/findContent';
import { GRAPHQL_ENV } from '../../../../../../../gql';

import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import UpSellProductsBuilder from './Paritials/UpSellProductsBuilder/UpSellProductsBuilder';

const GraphqlUpSellProducts = ({ brand }) => {
    const QUERY = findContent({
        brand: brand.domain,
        locale: 'en-us',
        contentType: 'checkout_product_recommendations',
    });

    return (
        <Query query={QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null;
                }

                if (error) {
                    mbpLogger.logError({
                        query: QUERY,
                        component: 'GraphqlProductRecommendation.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        query: QUERY,
                        component: 'GraphqlProductRecommendation.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                let partNumbers = null;
                if (data.findContent.content?.entries?.[0]?.part_number) {
                    partNumbers = data.findContent.content.entries[0].part_number;
                }

                if (partNumbers?.length > 0) {
                    return (
                        <UpSellProductsBuilder
                            brand={brand}
                            partNumbers={partNumbers}
                        />
                    );
                }

                return null;
            }}
        </Query>
    );
};

GraphqlUpSellProducts.propTypes = {
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapStateToProps)(GraphqlUpSellProducts);
